<script>
	export let html;
</script>

<div class="text_box">
	{@html html.fixImageAndApiLinkPath()}
</div>

<style global lang="scss">
	@import "../../style/variables";
	@import "../../style/mixins";
	
	.text_box {
		width: 100%;
		hyphens: auto;
		
		.special_0 {
			width: 100%;
		}
		
		[class*="special"] p {
			font-weight: 100;
		}
		
		[class*="special"] h2 {
			font-weight: 600;
		}
		
		.w_100.special_1 {
			background-color: $color-burgeins-3;
			display: flex;
			flex-flow: column;
			padding: calc(var(--spacing-mobile)*2) var(--spacing-mobile);
			margin-bottom: var(--spacing-mobile);
			
			@include for-tablet-landscape-up {
				flex-flow: row;
			}
			
			h4 {
				margin: 0 0 $spacing-mobile-half 0;
				
				@include for-tablet-landscape-up {
					font-size: 4rem;
					line-height: 4rem;
					margin: 0;
				}
			}
		}
		
		.w_100.special_no-margin-top h2 {
			margin-top: 0;
		}
		
		.w_100.special_w_100_55 {
			margin-top: calc(var(--spacing-mobile) * 1.5);
		}
		.special_w_100_55 h1 {
			width: 55%;
		}
		
		.special_w_100_60 h1 {
			@include for-tablet-portrait-up {
				width: 60%;
			}
		}
			
		.special_w_100_65 h1 {
			width: 65%;
		}
		
		.special_w_100_75 h1 {
			width: 75%;
		}
		
		.special_w_100_80 h1 {
			width: 80%;
		}
		
		.special_w_100_h2.w_100 h2 {
			@include font-px-to-rem(36, 45, 600);
			margin-bottom: calc(var(--spacing-mobile) * 2);
		}
		
		.special_w_100_h2.w_100 h3 {
			margin: calc(var(--spacing-mobile) / 3) 0;
		}
		
		.special_w_100_h2.w_100 p:not(:last-of-type) {
			margin-bottom: calc(var(--spacing-mobile));
		}
		
		.special_w_100_portfolio {
			p:first-of-type {
				margin-top: $spacing-mobile;
			}
			
			p {
				margin-bottom: $spacing-mobile-half;
			}
			
			h3,
			p:first-of-type, {
				margin-bottom: $spacing-mobile;
			}
		}
		
		.special_w_100_60 p {
			@include for-tablet-landscape-up {
				margin-bottom: $spacing-mobile-half;
			}
		}
		
		.w_60 {
			padding-left: 0;
			
			@include for-tablet-landscape-up {
				padding-left: 40%;
			}
		}
		
		.left.w_60 {
			padding-left: 0;
			padding-right: 40%;
		}
		
		.w_80 {
			padding-left: 20%;
		}
		
		.left.w_80 {
			padding-left: 0;
			padding-right: 20%;
		}
		
		.w_100 {
			width: 100%;
			//padding: 0 $spacing-mobile;
			
			h1 {
				margin: calc(var(--spacing-mobile) * 2) 0 var(--spacing-mobile);
			}
			
			h2 {
				margin: 0 $spacing-mobile $media-gap 0;
			}
			
			h3, h4 {
				margin-bottom: $spacing-mobile*.6;
			}
			
			h5 {
				margin: $spacing-mobile 0;
			}
		}
		
		p, img {
			width: 100%;
		}
		
		.right.w_60 p {
			padding: var(--spacing-mobile);
		}
		
		.special_headerwithbgcolor {
			margin: 0;
			background-color: black;
			
			@include for-tablet-landscape-up {
				img {
					height: 70vh;
					width: auto;
					margin: auto;
					display: block;
				}
			}
		}
		
		.special_header {
			margin: 0 $spacing-mobile;

			p::before {
				content: "-";
				color: black;
				transition: color .2s ease-in-out;
				position: absolute;
				font-size: 4em;
				font-weight: 600;
				line-height: 0;
				margin-top: 0.1em;
				margin-left: -0.7em;
			}
			
			@include for-tablet-portrait-up {
				margin-right: $spacing-mobile;

				p {
					width: 40vw;
				}
			}
		}
		
		.special_page-legal {
			a {
				text-decoration: underline;
				color: $color-burgeins-6;
				word-break: initial;
				hyphens: initial;
			}
			
			p:last-of-type {
				margin-bottom: $spacing-mobile*2;
			}
		}
		
		.special_margin-bottom {
			margin-bottom: $media-gap;
		}

		ul {
			margin-left: px-to-em(20);

			li {
				@include font-px-to-rem(18, 30, 100);

				@include for-desktop-up {
					@include font-px-to-rem(25, 40, 100);
				}
			}
		}

		:global(.images_before), :global(.images_after) {
			width: 100%;
			margin-bottom: $media-gap;
		}
	}

	:global(.useCustomCss) {
		.special_header {
			p::before {
				color: white;
			}
		}
		.w_100.special_1 {
			background-color: #7B7B7B;
		}
	}
</style>
